import { render, staticRenderFns } from "./LinkStaffServiceModal.vue?vue&type=template&id=c85f3a68&"
import script from "./LinkStaffServiceModal.vue?vue&type=script&lang=js&"
export * from "./LinkStaffServiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c85f3a68')) {
      api.createRecord('c85f3a68', component.options)
    } else {
      api.reload('c85f3a68', component.options)
    }
    module.hot.accept("./LinkStaffServiceModal.vue?vue&type=template&id=c85f3a68&", function () {
      api.rerender('c85f3a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/LinkStaffServiceModal.vue"
export default component.exports